module.exports = __webpack_public_path__ + "static/img/summer_jianjiePic.f41086a7.png";